import { Map } from "immutable";
import { CTCActions } from "./actions";

const initial_state = new Map({
  pep_ok: false,
  ingreso_ok: false,
  ctc_step_one_ok: false,
  ctc_step_two_ok: false,
  firma_ok: false,
  firma_svg: "",
  selectCedulaPas: 1,
  kyc_dt_part_ok: false,
  kyc_part_1_ok: false,
  kyc_part_2_ok: false,
  kyc_part_3_ok: false,
  kyc_endpoint_response: "",
  generate_solicitud_n_checklist_data: "",
  check_traffic_history_res: "",
});

export default function CTCReducer(state = initial_state, action) {
  switch (action.type) {
    case "persist/REHYDRATE":
      if (action.payload) {
        return new Map(action.payload.CTCReducer);
      } else {
        return state;
      }
    case CTCActions.PEP_OK:
      return state.set("pep_ok", action.pep_ok);
    case CTCActions.INGRESO_OK:
      return state.set("ingreso_ok", action.ingreso_ok);
    case CTCActions.CTC_STEP_ONE_OK:
      return state.set("ctc_step_one_ok", action.ctc_step_one_ok);
    case CTCActions.STEP_TWO_OK:
      return state.set("ctc_step_two_ok", action.ctc_step_two_ok);
    case CTCActions.FIRMA_OK:
      return state.set("firma_ok", action.firma_ok);
    case CTCActions.FIRMA_SVG:
      return state.set("firma_svg", action.firma_svg);
    case CTCActions.CEDULA_PASAPORTE:
      return state.set("selectCedulaPas", action.selectCedulaPas);
    case CTCActions.KYC_DT_PART_OK:
      return state.set("kyc_dt_part_ok", action.kyc_dt_part_ok);
    case CTCActions.KYC_PART_1_OK:
      return state.set("kyc_part_1_ok", action.kyc_part_1_ok);
    case CTCActions.KYC_PART_2_OK:
      return state.set("kyc_part_2_ok", action.kyc_part_2_ok);
    case CTCActions.KYC_PART_3_OK:
      return state.set("kyc_part_3_ok", action.kyc_part_3_ok);
    case CTCActions.KYC_ENDPOINT_RESPONSE:
      return state.set("kyc_endpoint_response", action.kyc_endpoint_response);
    case CTCActions.GENERATE_SOLICITUD_N_CHECKLIST_DATA:
      return state.set(
        "generate_solicitud_n_checklist_data",
        action.generate_solicitud_n_checklist_data
      );
    case CTCActions.CHECK_TRAFFIC_HISTORY_RES:
      return state.set(
        "check_traffic_history_res",
        action.check_traffic_history_res
      );

    default:
      return state;
  }
}
